import { Drawer, Paper, Stack } from '@mui/material';
import {
	DrawerRegisterContentSx,
	DrawerRegisterFrameSx,
} from '@/components/content/Cart/parts/DrawerRegister/styles/main';
import { Register } from '@/components/content/Register';

interface DrawerLoginProps {
	onGoBack: () => void;
	onClose: () => void;
}

export const DrawerRegister: React.FC<DrawerLoginProps> = ({ onGoBack, onClose }) => (
	<Drawer open>
		<Paper sx={DrawerRegisterFrameSx}>
			<Stack sx={DrawerRegisterContentSx}>
				<Register
					id={''}
					withoutLogin
					onGoBack={onGoBack}
					onClose={onClose}
					adaptWith
					origin="cart"
				/>
			</Stack>
		</Paper>
	</Drawer>
);
